// extracted by mini-css-extract-plugin
export default {"greetingSection":"component-styles_greetingSection__Bru59","greetText":"component-styles_greetText__0DgKx","userName":"component-styles_userName__AdlNI"};